const atualizarUnidadesMedida = (state, unidadesMedida) => {
    state.unidadesMedida = unidadesMedida;
}

const atualizarUnidadeMedida = (state, unidadeMedida) => {
    state.unidadeMedida = unidadeMedida;
}

const addUnidadeMedida = (state, unidadeMedida) => {
    if (!unidadeMedida || unidadeMedida.id == null) return;

    state.unidadesMedida.push(JSON.parse(JSON.stringify(unidadeMedida)));
}

const updateUnidadeMedida = (state, unidadeMedida) => {
    if (!unidadeMedida || unidadeMedida.id == null) return;

    const index = state.unidadesMedida.findIndex(item => item.id === unidadeMedida.id);
    if (index >= 0) {
        state.unidadesMedida.splice(index, 1, JSON.parse(JSON.stringify(unidadeMedida)));
    }
}

export default {
    atualizarUnidadesMedida,
    atualizarUnidadeMedida,
    addUnidadeMedida,
    updateUnidadeMedida
}
